import { single } from "./actionType";

export const Single=(data)=>(
 {
    type:single,payload:data
 }   
)